(() => {
  const initFaq = (root) => {
    const input = root.querySelector('[data-faq-search]');
    if (!input) return;

    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
    const empty = root.querySelector('[data-faq-empty]');
    const count = root.querySelector('[data-faq-result-count]');
    const clear = root.querySelector('[data-faq-clear]');

    const update = () => {
      const term = input.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const matches = !term || (item.dataset.searchText || '').includes(term);
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
      });

      if (empty) empty.hidden = visibleCount !== 0;
      if (clear) clear.hidden = !term;
      if (count) count.textContent = term ? `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'} found` : '';
    };

    input.addEventListener('input', update);
    clear?.addEventListener('click', () => {
      input.value = '';
      input.focus();
      update();
    });
  };

  document.querySelectorAll('[data-altoff-faq]').forEach(initFaq);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-altoff-faq]').forEach(initFaq);
  });
})();
